export default "__VITE_PUBLIC_ASSET__e959c849__"